import { AccessibilityService } from '@shared/services/accessibility.service';
import { DatePicker } from 'primeng/datepicker';
import { exclusionCategoryEnum } from './../../../constants/exclusionCategory';
import { LoggingService, MessagingService } from '@oneeducation/app-core';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  HostListener,
  ElementRef,
  AfterContentChecked,
  ViewChildren,
  QueryList,
  inject
} from '@angular/core';
import {
  AcademicYearTerm,
  exclusionsModel,
  nonSchoolDaysModel,
  pupilModel
} from '@exclusionmodule/models';
import {
  ApiServiceService,
  NotificationService,
  ValidateFormDataService
} from '@oneeducation/app-core';
import {
  EXCLUSION_ENDPOINT,
  STUDENT_ENDPOINT,
  ADMIN_ENDPOINT,
  BASE_ENDPOINT
} from '@shared/properties';
import { DataLossService, DataSortService } from '@shared/services';
import {
  DirtyComponent,
  LookupModel,
  propertyTypeEnum,
  sortOrderEnum
} from '@shared/models';
import {
  exclusionMeeting,
  ExclusionMeetingEnum,
  meetingTypeCollection
} from '@exclusionmodule/models/exclusion-meeting.model';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  ERROR_GETTING_MEETING_DETAILS,
  GOVERNING_BODY_MEETING,
  INDEPENDENT_PANEL_APPEAL_MEETING,
  MEETING_ATTENDANCE_CARER,
  MEETING_ATTENDANCE_OFFICER,
  MEETING_ATTENDANCE_SEN_EXPERT,
  MEETING_REQUESTED_BY,
  MEETING_REQUEST_CARER,
  SEN_EXPERT_NOT_REQUESTED_BY_CARER,
  SEN_EXPERT_REQUESTED_BY_CARER,
  TRUE_VALUE
} from '@exclusionmodule/constants';
import { ConfirmationService } from 'primeng/api';
import { holidayTypesEnum } from '@schoolmanagement/constants';
import { Subscription } from 'rxjs';
import { Select } from 'primeng/select';
import { DateService } from '@shared/services/date.service';
import { dateFormatEnum } from '@shared/services/date-constants';
import { DateControlValidationsService } from '@shared/services/date-control-validations.service';
const err_requested_date_after_start_date_api_msg =
  'Requested date must be on or after start date';
const err_requested_date_after_start_date =
  'Requested date must be on or after start date';

@Component({
  selector: 'app-exclusion-meetings',
  templateUrl: './exclusion-meetings.component.html',
  styleUrls: ['./exclusion-meetings.component.scss'],
  standalone: false
})
export class ExclusionMeetingsComponent
  implements OnInit, OnDestroy, DirtyComponent, AfterContentChecked
{
  private readonly apiService = inject(ApiServiceService);
  private readonly notificationService = inject(NotificationService);
  private readonly dataSortService = inject(DataSortService);
  private readonly datePipe = inject(DatePipe);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly validateFormDataService = inject(ValidateFormDataService);
  private readonly loggingService = inject(LoggingService);
  private readonly messagingService = inject(MessagingService);
  private readonly dataLossService = inject(DataLossService);
  private readonly dateService = inject(DateService);
  private readonly dateControlValidationService = inject(
    DateControlValidationsService
  );
  private readonly accessibilityService = inject(AccessibilityService);
  private readonly elementRef = inject(ElementRef);

  @Input() exclusionId: number;
  @Input() pupilData: pupilModel;
  @Input() isOffRollEditingEnabled: boolean;
  @Input() schoolId: number;
  @ViewChild('addMeetingButton') addMeetingButton: ElementRef;
  @ViewChild('dropdownMeetingType') dropdownMeetingType: Select;
  @ViewChild('meetingStatusDropdown') meetingStatusDropdown: Select;
  @ViewChild('meetingOutcomeDropdown') meetingOutcomeDropdown: Select;
  @ViewChild('reinstateReasonDropdown') reinstateReasonDropdown: Select;
  @ViewChild('calendarMeetingDateTime') calendarMeetingDateTime: DatePicker;
  @ViewChild('allMeetings') allMeetings: ElementRef;
  @ViewChild('addEditMeetingPopUp') addEditMeetingPopUp: any;
  @ViewChildren('editMeetingSplitButton', { read: ElementRef })
  editMeetingSplitButton: QueryList<ElementRef>;
  exclusionStartDate: Date;
  exclusionEndDate: Date;
  exclusionCategory: string;
  meetings: exclusionMeeting[];
  meeting: exclusionMeeting;
  meetingDataFoundMessage: boolean;
  displayDateFormat = 'dd/MM/yyyy';
  datetimeFormat = 'yyyy/MM/dd HH:mm';
  dateFormat = 'yyyy/MM/dd';
  popupHeaderText: string;
  splitActionButtons = [];
  display: boolean;
  meetingTypes: { value: string; description: string }[];
  meetingStatusOptions: LookupModel;
  meetingOutcomeOptions: LookupModel;
  isMeeting = true;
  minDateMeeting: Date;
  maxDateMeeting: Date;
  minDateAppealMeeting: Date;
  maxReinstateDate: Date;
  minDate = new Date();
  isSaveClicked: boolean;
  selectedMeeting: string;
  isInvalidDate: boolean;
  yearRangeNavigator: string;
  noMeetingsCreatedMessage: string;
  isEdit: boolean;
  meetingAppealId: number;
  isSenExpertAttendedChecked: boolean;
  confirmDialogAcceptButtonLabel: string;
  isInputDateInValid: boolean;
  nonSchoolDays: nonSchoolDaysModel[];
  nonSchoolDates: Date[];
  isReinstateFieldsVisible: boolean;
  reinstateReasonList: any[];
  alertSubscription: Subscription;
  componentDetail = {
    componentName: 'Meetings',
    formNameToCheckForDirtyness: 'meetingFields'
  };
  maxAcademicYearDate: Date;
  meetingIndex: number;
  readonly dateTimeInputFormat: string = 'dd/MM/yyyy HH:mm';
  selectedMeetingRowIndex = -1;
  isDeleteAction = false;

  //Form fields
  meetingFields = new FormGroup({
    meetingType: new FormControl<string | null>(null),
    meetingDateTime: new FormControl<Date | null>(null),
    requestedDate: new FormControl<Date | null>(null),
    meetingStatus: new FormControl<string | null>(null),
    appealMeetingDateTime: new FormControl<Date | null>(null),
    pupilAppellant: new FormControl<boolean | null>(null),
    decisionResult: new FormControl<string | null>(null),
    carersAttended: new FormControl<boolean | null>(null),
    senExpertAttended: new FormControl<boolean | null>(null),
    senExpertAttendedDetails: new FormControl<string | null>(null),
    reinstatementDate: new FormControl<Date | null>(null),
    reinstatementReason: new FormControl<string | null>(null)
  });
  exclusion: exclusionsModel;

  constructor() {
    this.alertSubscription = this.messagingService
      .getAlert()
      .subscribe((arg) => {
        if (arg.value && this.isValidCategory(arg.value) != -1) {
          this.exclusionCategory = arg.value;
          this.getMeetings();
        }
      });
  }

  ngOnInit() {
    this.getExclusionDetails();
    this.getMeetings();
    this.getNonSchoolDays();
  }

  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
  }

  // Get all academic year and term for the base
  private getAcademicYearEndDate() {
    const apiRoute = BASE_ENDPOINT.GetTermAndAcademicYear.replace(
      '{schoolId}',
      this.schoolId?.toString()
    );

    this.apiService.get<AcademicYearTerm>(apiRoute, '').subscribe({
      next: (x: any) => {
        this.maxAcademicYearDate =
          this.dateService.GetAcademicYearEndDateFromAcademicYearsTerms(
            this.exclusionStartDate,
            x.academicyearterm
          );
        if (
          this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_PERMANENT
        ) {
          this.maxReinstateDate = this.maxAcademicYearDate;
        }

        this.setMaxMeetingDate();
      },
      error: () => {
        this.notificationService.showError(
          'Error getting academic year end date'
        );
      }
    });
  }

  private setMaxMeetingDate() {
    if (
      this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_PERMANENT ||
      this.exclusionCategory ===
        exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM ||
      (this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_WARNING &&
        this.exclusion.endDate == null)
    ) {
      this.maxDateMeeting = new Date(this.maxAcademicYearDate);
    } else if (
      this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_FIXED ||
      this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_SUSPENSION ||
      this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_LUNCHTIME ||
      this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_WARNING ||
      this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_OTHER
    ) {
      this.maxDateMeeting = new Date(this.exclusionEndDate);
    }
    // Meeting time should be configuration on Exclusion end date
    this.maxDateMeeting.setHours(23, 59, 59);
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleKeyboardEvent() {
    // If add/edit meeting pop-up then call 'closePopup' method
    // else delete meeting pop-up is open, so on close set focus on the clicked menu item
    if (this.addEditMeetingPopUp.container) this.closePopup();
    else this.setFocusOnSplitButtonMenu();
  }

  private getMeetings() {
    this.isMeeting = true;
    this.isSaveClicked = false;
    this.isInvalidDate = false;
    this.isInputDateInValid = false;
    this.meetingDataFoundMessage = false;
    this.isSenExpertAttendedChecked = false;
    this.getNoMeetingsCreatedMessage();
    this.meetingTypes = meetingTypeCollection;
    if (this.exclusionEndDate != null) {
      this.maxReinstateDate = new Date(this.exclusionEndDate);
    }
    const apiRoute = EXCLUSION_ENDPOINT.GetExclusionMeetingAppeals.replace(
      '{exclusionId}',
      this.exclusionId?.toString()
    );
    this.apiService.getAll<any[]>(apiRoute, '').subscribe({
      next: (x: any) => {
        this.meetings = x.meetingappeal;
        this.SortMeetings();
        this.GetMeetingDetails();
      },
      error: (x: any) => {
        if (x.error.statusCode === 404) {
          this.meetingDataFoundMessage = true;

          // Set focus on the add button as there are not meetings
          this.isDeleteAction = false;
          this.selectedMeetingRowIndex = -1;
          this.setFocusOnAddMeetingButton();
        } else {
          this.notificationService.showError(ERROR_GETTING_MEETING_DETAILS);
        }
      }
    });
  }

  private getExclusionDetails() {
    this.apiService
      .get<exclusionsModel>(
        EXCLUSION_ENDPOINT.GetExclusion.replace(
          '{exclusionId}',
          this.exclusionId?.toString()
        ),
        ''
      )
      .subscribe({
        next: (x: any) => {
          this.exclusion = null;
          this.exclusion = x.exclusion;
          this.exclusionCategory = this.exclusion.categoryExtCode;
          this.exclusionStartDate = this.exclusion.startDate;
          this.exclusionEndDate = this.exclusion.endDate;
          this.setMinMaxDates();
          this.getAcademicYearEndDate();
        },
        error: () => {
          this.notificationService.showError(
            'Something went wrong, please try again.'
          );
        }
      });
  }

  private getNonSchoolDays() {
    this.nonSchoolDates = [];
    const apiRoute = this.getNonSchoolDaysApiRoute();
    this.apiService.getAll<nonSchoolDaysModel[]>(apiRoute, '').subscribe({
      next: (x: any) => {
        this.nonSchoolDays = x.nonschooldays;

        if (this.nonSchoolDays != null && this.exclusionStartDate != null) {
          const filterNonSchoolDays: nonSchoolDaysModel[] =
            this.nonSchoolDays.filter(
              (x) =>
                new Date(x.nonSchoolDate).getTime() >=
                  new Date(this.exclusionStartDate).getTime() &&
                (x.nonSchoolDayReason.trim() == holidayTypesEnum.HOLIDAY ||
                  x.nonSchoolDayReason.trim() == holidayTypesEnum.STAFF_DAY ||
                  x.nonSchoolDayReason.trim() ==
                    holidayTypesEnum.FORCED_CLOSURE)
            );
          if (filterNonSchoolDays != null) {
            filterNonSchoolDays.forEach((x) => {
              this.nonSchoolDates.push(new Date(x.nonSchoolDate));
            });
          }
        }
      },
      error: () => {
        this.notificationService.showError('Error getting non school days');
      }
    });
  }

  private getNonSchoolDaysApiRoute() {
    return STUDENT_ENDPOINT.GetNonSchoolDays.replace(
      '{studentId}',
      this.pupilData.studentId
    ).replace('{schoolId}', this.schoolId?.toString());
  }

  getNoMeetingsCreatedMessage() {
    if (this.pupilData.studentName != null) {
      const index = this.pupilData.studentName.indexOf(' ');
      if (index > 0) {
        this.noMeetingsCreatedMessage =
          'No meetings have been created for ' +
          this.pupilData.studentName.substr(0, index);
      } else {
        this.noMeetingsCreatedMessage =
          'No meetings have been created for ' + this.pupilData.studentName;
      }
    } else {
      this.noMeetingsCreatedMessage = 'No meetings have been created';
    }
  }

  private GetMeetingDetails() {
    this.splitActionButtons = [];
    this.meetings.forEach((x) => {
      if (x.meetingType == ExclusionMeetingEnum.Meeting) {
        x.meetingTypeInfo = GOVERNING_BODY_MEETING;
        const FormattedGoverningMeetingTime = x.meetingDateTime?.substring(
          11,
          16
        );
        if (x.meetingDate != null) {
          x.meetingDateMsg =
            this.datePipe.transform(x.meetingDate, this.displayDateFormat) +
            ' at ' +
            FormattedGoverningMeetingTime;
        }
      } else if (x.meetingType == ExclusionMeetingEnum.Appeal) {
        x.meetingTypeInfo = INDEPENDENT_PANEL_APPEAL_MEETING;
        const FormattedAppealMeetingTime = x.meetingDateTime?.substring(11, 16);
        if (x.meetingDate != null) {
          x.meetingDateMsg =
            this.datePipe.transform(x.meetingDate, this.displayDateFormat) +
            ' at ' +
            FormattedAppealMeetingTime;
        }
        x.SENExpertRevReqMsg =
          x.senExpertAttended == 'True'
            ? SEN_EXPERT_REQUESTED_BY_CARER
            : SEN_EXPERT_NOT_REQUESTED_BY_CARER;

        if (x.pupilAppellant == 'True') {
          x.appealMeetingRequestMsg = MEETING_REQUESTED_BY.replace(
            '{0}',
            this.datePipe.transform(x.requestedDate, this.displayDateFormat)
          ).replace(
            '{1}',
            this.pupilData.studentName.substring(
              0,
              this.pupilData.studentName.indexOf(' ') > -1
                ? this.pupilData.studentName.indexOf(' ')
                : this.pupilData.studentName.length
            ) + ' (the pupil)'
          );
        } else {
          x.appealMeetingRequestMsg = MEETING_REQUESTED_BY.replace(
            '{0}',
            this.datePipe.transform(x.requestedDate, this.displayDateFormat)
          ).replace('{1}', MEETING_REQUEST_CARER);
        }
      }

      // Set the Yes/No flags
      x.carersAttendedFlag = x.carersAttended == 'True' ? 'Yes' : 'No';
      x.pupilAppellantFlag = x.pupilAppellant == 'True' ? 'Yes' : 'No';
      x.senExpertAttendedFlag = x.senExpertAttended == 'True' ? 'Yes' : 'No';

      this.GetMeetingAttendees(x);

      //Assign meetingAppealId & meetingType to delete split action button
      const splitActionDeleteButton = [
        {
          label: 'Delete',
          styleClass: 'p-splitbutton p-component align-center',
          command: () => {
            this.deleteMeeting(x.meetingAppealId, x.meetingType);
          }
        }
      ];

      this.splitActionButtons.push(splitActionDeleteButton);
    });

    // Set focus on Edit or Add Button
    if (this.isDeleteAction) {
      this.setFocusOnSplitButtonMenu();
    } else {
      this.setFocusOnAddMeetingButton();
    }
  }

  private GetMeetingTypeInfo(meetingType: string) {
    if (meetingType == ExclusionMeetingEnum.Meeting) {
      return GOVERNING_BODY_MEETING;
    } else if (meetingType == ExclusionMeetingEnum.Appeal) {
      return INDEPENDENT_PANEL_APPEAL_MEETING;
    } else {
      return '';
    }
  }

  // Get the meeting attendees
  private GetMeetingAttendees(x: exclusionMeeting) {
    x.meetingAttendees = [];
    // Carers
    if (x.carersAttended == 'True') {
      x.meetingAttendees.push(MEETING_ATTENDANCE_CARER);
    }

    // SEN Expert
    if (
      x.meetingType == ExclusionMeetingEnum.Appeal &&
      x.senExpertAttended == 'True'
    ) {
      if (x.senExpertAttendedDetails) {
        x.meetingAttendees.push(
          MEETING_ATTENDANCE_SEN_EXPERT.replace(
            '{0}',
            x.senExpertAttendedDetails
          )
        );
      } else {
        x.meetingAttendees.push(
          MEETING_ATTENDANCE_SEN_EXPERT.replace('{0}', 'Unknown')
        );
      }
    }

    // Officer
    if (
      x.meetingType == ExclusionMeetingEnum.Meeting &&
      x.officerAttendingName
    ) {
      x.meetingAttendees.push(
        MEETING_ATTENDANCE_OFFICER.replace('{0}', x.officerAttendingName)
      );
    }
  }

  // Sort the meetings based on meeting date time
  private SortMeetings() {
    this.dataSortService.sortData(
      this.meetings,
      'meetingDateTime',
      propertyTypeEnum.date,
      sortOrderEnum.descending
    );
  }

  //Get lookup API route
  private getLookupApiRoute(lookupTableId: string) {
    return (
      ADMIN_ENDPOINT.GetLookups.replace('{tableId}', lookupTableId) +
      '?active=True'
    );
  }

  //Set min date based on Exclusion Start Date
  private setMinMaxDates() {
    if (this.exclusionStartDate) {
      this.minDateMeeting = new Date(this.exclusionStartDate);

      // In Add exclusion meeting mode set the appeal meeting date/time calendar minimum date to exclusion start date
      if (!this.isEdit) {
        this.setMinAppealDate(this.minDateMeeting);
      }
    }
    if (this.exclusionEndDate != null) {
      this.maxReinstateDate = new Date(this.exclusionEndDate);
    }
  }

  deleteMeeting(meetingAppealId: number, meetingType: string) {
    const meetingTypeInfo = this.GetMeetingTypeInfo(meetingType);
    this.dataLossService.removeComponentFromUnsavedChanges(this);
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the ' + meetingTypeInfo + '?',
      header: 'Delete Meeting',
      acceptLabel: 'Delete',
      rejectLabel: 'Cancel',
      reject: () => {
        this.setFocusOnSplitButtonMenu();
      },
      accept: () => {
        const apiRoute = this.getDeleteApiRoute(meetingAppealId, meetingType);
        this.apiService.delete<any>(apiRoute, '').subscribe({
          next: (x: any) => {
            if (parseInt(x.statusCode) === 200) {
              this.notificationService.showSuccess(
                meetingTypeInfo + ' deleted successfully!'
              );

              this.isDeleteAction = true;
              this.getMeetings();
              this.messagingService.sendAlert('upheldOutcomeMeetingDeleted');
            }
          },
          error: () => {
            this.notificationService.showError(
              'Something went wrong, please try again.'
            );
          }
        });
      }
    });
  }

  private getDeleteApiRoute(meetingId: number, meetingType: string) {
    const apiRoute =
      meetingType == ExclusionMeetingEnum.Meeting
        ? EXCLUSION_ENDPOINT.DeleteExclusionMeeting.replace(
            '{exclusionId}',
            this.exclusionId?.toString()
          ).replace('{meetingId}', meetingId?.toString())
        : EXCLUSION_ENDPOINT.DeleteExclusionAppeal.replace(
            '{exclusionId}',
            this.exclusionId?.toString()
          ).replace('{appealId}', meetingId?.toString());
    return apiRoute;
  }

  // Populate the lookup options
  private populateLookupOptions(lookupTableId: string, table: string): any {
    // Check if the data is already binded
    // If yes then prevent the data binding
    let isDataBindingRequired = true;
    if (table == 'ReinstateReason' && this.reinstateReasonList) {
      isDataBindingRequired = false;
    }
    if (isDataBindingRequired) {
      const apiRoute = this.getLookupApiRoute(lookupTableId);
      this.apiService.getAll<any[]>(apiRoute, '').subscribe({
        next: (x: any) => {
          if (table == 'Status') this.meetingStatusOptions = x.lookups;
          else if (table == 'ReinstateReason')
            this.reinstateReasonList = x.lookups;
          else if (table == 'Outcome') this.meetingOutcomeOptions = x.lookups;
        },
        error: () => {
          this.notificationService.showError(
            'Error getting the lookup options'
          );
        }
      });
    }
  }

  onOutcomeChange(outcome) {
    if (outcome == null) {
      return;
    }
    if (this.isFixedPeriodOrPermanent() && this.isOutcomeReinstate(outcome)) {
      this.manageReinstateFields(true);
    } else {
      this.manageReinstateFields(false);
    }
  }

  isOutcomeReinstate(outcome) {
    return (
      outcome?.toLowerCase() === 'reinstated' ||
      outcome?.toLowerCase() === 'reinstatement'
    );
  }

  isOutcomeUpheld(outcome) {
    return outcome?.toLowerCase() === 'upheld';
  }

  isOutcomeDeffered(outcome) {
    return outcome?.toLowerCase() === 'deferred';
  }

  isFixedPeriodOrPermanent() {
    return (
      this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_FIXED ||
      this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_SUSPENSION ||
      this.exclusionCategory === exclusionCategoryEnum.EXT_CODE_PERMANENT
    );
  }

  isValidCategory(category) {
    return Object.keys(exclusionCategoryEnum).findIndex(
      (key) =>
        category.toLowerCase() === exclusionCategoryEnum[key].toLowerCase()
    );
  }

  //Change validators and lookups value based on meeting Governing/Appeal
  private setConditionalValidators() {
    const meetingDateTimeControl = this.meetingFields.get('meetingDateTime');
    const requestedDateControl = this.meetingFields.get('requestedDate');
    const pupilAppellantControl = this.meetingFields.get('pupilAppellant');
    const appealMeetingDateTimeControl = this.meetingFields.get(
      'appealMeetingDateTime'
    );
    this.meetingFields.get('meetingStatus').setValue(null);

    requestedDateControl.clearValidators();
    meetingDateTimeControl.clearValidators();
    this.meetingStatusOptions = null;

    if (this.isMeeting) {
      meetingDateTimeControl.setValidators(Validators.required);
      requestedDateControl.setValue(null);
      pupilAppellantControl.setValue(null);
      appealMeetingDateTimeControl.setValue(null);
      this.populateLookupOptions('1104', 'Status');
    } else {
      requestedDateControl.setValidators(Validators.required);
      meetingDateTimeControl.setValue(null);
      this.populateLookupOptions('1105', 'Status');
    }
    meetingDateTimeControl.updateValueAndValidity();
    requestedDateControl.updateValueAndValidity();
  }

  private appealRequestedDateValidation() {
    this.isInvalidDate = false;

    const appealMeetingDateValue =
      this.meetingFields.controls['appealMeetingDateTime'].value;

    // Meeting date should be on or after meeting requested date
    if (appealMeetingDateValue) {
      this.isInvalidDate =
        appealMeetingDateValue &&
        this.minDateAppealMeeting > appealMeetingDateValue;
    }
  }

  // When user types manually in appeal meeting date time input field
  onManualDateTimeEnter(event) {
    this.isInvalidDate = false;
    this.isInputDateInValid = false;
    const inputDate = event.target.value;
    this.validateAppealMeetingDateTime(inputDate);
  }

  // Check whether appeal meeting date time is valid
  validateAppealMeetingDateTime(inputDate: string) {
    if (
      !this.dateService.checkEmptyDate(inputDate) ||
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyyhhmm,
        this.f.appealMeetingDateTime
      )
    ) {
      return;
    }
    const dt = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );
    if (
      !this.dateControlValidationService.checkDateBeforeMeetingRequestedDate(
        dt,
        this.f.requestedDate.value,
        this.f.appealMeetingDateTime
      ) ||
      !this.dateControlValidationService.checkDateBeforeExclusionStartDate(
        dt,
        this.exclusionStartDate,
        this.f.appealMeetingDateTime
      ) ||
      !this.dateControlValidationService.checkDateAfterExclusionEndDate(
        dt,
        this.exclusionEndDate,
        this.f.appealMeetingDateTime
      ) ||
      !this.dateControlValidationService.checkDateAfterAcademicYearEndDate(
        dt,
        this.maxAcademicYearDate,
        this.f.appealMeetingDateTime
      ) ||
      !this.dateControlValidationService.checkNonSchoolDate(
        dt,
        this.nonSchoolDates,
        this.f.appealMeetingDateTime
      )
    ) {
      return;
    }
  }

  // Validate all the date inputs
  private validateDateInputs() {
    // Governing body meeting date and time
    if (
      this.meetingFields.controls.meetingDateTime.value &&
      !this.meetingFields.controls.meetingDateTime.errors
    ) {
      const meetingDateTime = this.datePipe.transform(
        this.meetingFields.controls.meetingDateTime.value,
        this.dateTimeInputFormat
      );
      this.validateMeetingDateTime(meetingDateTime);
    }
    // Appeal meeting date time
    if (
      this.meetingFields.controls.appealMeetingDateTime.value &&
      !this.meetingFields.controls.appealMeetingDateTime.errors
    ) {
      const appealMeetingDateTime = this.datePipe.transform(
        this.meetingFields.controls.appealMeetingDateTime.value,
        this.dateTimeInputFormat
      );
      this.validateAppealMeetingDateTime(appealMeetingDateTime);
    }
    // Requested meeting date
    if (
      this.meetingFields.controls.requestedDate.value &&
      !this.meetingFields.controls.requestedDate.errors
    ) {
      const requestedDate = this.datePipe.transform(
        this.meetingFields.controls.requestedDate.value,
        this.displayDateFormat
      );
      this.validateRequestedMeetingDate(requestedDate);
    }
  }

  // When user types manually in meeting date time input field
  onManualMeetingDateTimeEntered(event) {
    this.isInputDateInValid = false;
    const inputDate = event.target.value;
    this.validateMeetingDateTime(inputDate);
  }

  // Check whether governing body meeting date time is valid
  validateMeetingDateTime(inputDate: string) {
    if (
      !this.dateService.checkEmptyDate(inputDate) ||
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyyhhmm,
        this.f.meetingDateTime
      )
    ) {
      return;
    }
    const dt = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );
    if (
      !this.dateControlValidationService.checkDateBeforeExclusionStartDate(
        dt,
        this.exclusionStartDate,
        this.f.meetingDateTime
      ) ||
      !this.dateControlValidationService.checkDateAfterExclusionEndDate(
        dt,
        this.exclusionEndDate,
        this.f.meetingDateTime
      ) ||
      !this.dateControlValidationService.checkDateAfterAcademicYearEndDate(
        dt,
        this.maxAcademicYearDate,
        this.f.meetingDateTime
      ) ||
      !this.dateControlValidationService.checkNonSchoolDate(
        dt,
        this.nonSchoolDates,
        this.f.meetingDateTime
      )
    ) {
      return;
    }
  }

  get f() {
    return this.meetingFields.controls;
  }

  //Display the Edit meeting/appeal popup
  showEditMeetingDialog(
    meetingAppealId: number,
    meetingType: string,
    rowIndex: number
  ) {
    this.selectedMeetingRowIndex = rowIndex;
    this.getExclusionDetails();
    this.isEdit = true;
    this.manageReinstateFields(false);
    this.meetingAppealId = meetingAppealId;
    this.clearValidationForSENExpertAttendedDetails();

    const currentMeeting: exclusionMeeting = this.meetings.find(
      (x) => x.meetingAppealId == this.meetingAppealId
    );
    if (currentMeeting != null) {
      this.isMeeting = meetingType == ExclusionMeetingEnum.Meeting;
      this.isInvalidDate = false;
      this.meetingFields.reset();
      this.setConditionalValidators();
      this.populateEditDialog(currentMeeting);
    }

    this.display = true;

    this.meetingFields.valueChanges.subscribe(() => {
      this.dataLossService.addComponentToCheckUnsavedChanges(this);
    });
  }

  manageReinstateFields(showReinstateFields: boolean) {
    const reinstatementDate = this.meetingFields.get('reinstatementDate');
    const reinstatementReason = this.meetingFields.get('reinstatementReason');
    if (showReinstateFields) {
      reinstatementDate.setValidators(Validators.required);
      reinstatementReason.setValidators(Validators.required);
      reinstatementDate.reset();
      reinstatementReason.reset();
      this.populateLookupOptions('0462', 'ReinstateReason');
    } else {
      reinstatementDate.clearValidators();
      reinstatementReason.clearValidators();
    }
    reinstatementDate.updateValueAndValidity();
    reinstatementReason.updateValueAndValidity();
    this.isReinstateFieldsVisible = showReinstateFields;
  }

  //Populate the edit dialog with values
  populateEditDialog(currentMeeting: exclusionMeeting) {
    this.popupHeaderText = 'Edit ' + currentMeeting.meetingTypeInfo;
    this.createYearRange();
    this.meetingFields.get('meetingType').setValue(currentMeeting.meetingType);
    this.meetingFields
      .get('meetingStatus')
      .setValue(currentMeeting.meetingStatus);
    this.meetingFields
      .get('decisionResult')
      .setValue(currentMeeting?.decisionResult);
    if (
      currentMeeting.carersAttended.toLowerCase() == TRUE_VALUE.toLowerCase()
    ) {
      this.meetingFields.get('carersAttended').setValue(true);
    }
    //Governing Body
    if (this.isMeeting) {
      this.meetingStatusOptions = this.populateLookupOptions('1104', 'Status');
      this.meetingOutcomeOptions = this.populateLookupOptions(
        '0527',
        'Outcome'
      );
      this.meetingFields
        .get('meetingDateTime')
        .setValue(new Date(currentMeeting.meetingDateTime));
    }
    //Appeal
    else {
      this.meetingStatusOptions = this.populateLookupOptions('1105', 'Status');
      this.meetingOutcomeOptions = this.populateLookupOptions(
        '0311',
        'Outcome'
      );

      this.meetingFields
        .get('requestedDate')
        .setValue(new Date(currentMeeting.requestedDate));
      const minReuestDate =
        currentMeeting.requestedDate == null
          ? new Date(this.exclusion.startDate)
          : new Date(currentMeeting.requestedDate);
      this.setMinAppealDate(minReuestDate);

      if (currentMeeting.meetingDateTime) {
        this.meetingFields
          .get('appealMeetingDateTime')
          .setValue(new Date(currentMeeting.meetingDateTime));
      }

      if (
        currentMeeting.pupilAppellant.toLowerCase() == TRUE_VALUE.toLowerCase()
      ) {
        this.meetingFields.get('pupilAppellant').setValue(true);
      }

      if (
        currentMeeting.senExpertAttended.toLowerCase() ==
        TRUE_VALUE.toLowerCase()
      ) {
        this.isSenExpertAttendedChecked = true;
        this.meetingFields.get('senExpertAttended').setValue(true);

        const senExpertAttendedDetailsControl = this.meetingFields.get(
          'senExpertAttendedDetails'
        );

        senExpertAttendedDetailsControl.setValue(
          currentMeeting.senExpertAttendedDetails
        );

        senExpertAttendedDetailsControl.setValidators(Validators.required);
      }
    }

    if (currentMeeting.reinstatementDate != null) {
      this.meetingFields
        .get('reinstatementDate')
        .setValue(new Date(currentMeeting.reinstatementDate));
    }
    this.meetingFields
      .get('reinstatementReason')
      .setValue(currentMeeting.reinstatementReason);
    this.onOutcomeChange(currentMeeting?.decisionResult);
    this.meetingFields.valueChanges.subscribe(() => {
      this.dataLossService.addComponentToCheckUnsavedChanges(this);
    });
  }

  //Initial focus on first control of Add Meeting Dialog
  focusFirstInputControl() {
    if (this.isEdit) {
      if (this.calendarMeetingDateTime) {
        this.calendarMeetingDateTime.inputfieldViewChild.nativeElement.focus();
      }
    } else {
      if (this.dropdownMeetingType) {
        this.dropdownMeetingType.focus();
      }
    }
  }

  //Display add meeting dialog
  showAddMeetingDialog() {
    this.selectedMeetingRowIndex = -1;
    this.getExclusionDetails();
    this.isMeeting = true;
    this.isEdit = false;
    this.manageReinstateFields(false);
    this.meetingFields.reset();
    this.meetingFields
      .get('meetingType')
      .setValue(ExclusionMeetingEnum.Meeting.toString());
    this.createYearRange();
    this.setConditionalValidators();
    this.popupHeaderText = 'Add a Meeting for ' + this.pupilData.studentName;
    this.display = true;

    this.meetingFields.valueChanges.subscribe(() => {
      this.dataLossService.addComponentToCheckUnsavedChanges(this);
    });
  }

  //Create Year Range
  createYearRange() {
    //need to display year range in drop down i.e. previous 11 years and next 2 years
    const currentYear = new Date().getFullYear();
    this.yearRangeNavigator = currentYear - 11 + ':' + (currentYear + 2);
  }

  //close popup
  closePopup() {
    if (this.dataLossService.checkForUnsavedChanges(this)) {
      this.resetToOriginal();
    }
  }

  private setFocusOnAddMeetingButton() {
    if (this.selectedMeetingRowIndex === -1 && this.addMeetingButton) {
      this.addMeetingButton?.nativeElement?.focus();
    } else if (
      this.selectedMeetingRowIndex > -1 &&
      this.editMeetingSplitButton
    ) {
      this.setFocusOnEditMeetingButton();
    }
  }

  private setFocusOnEditMeetingButton() {
    setTimeout(() => {
      const selectedMeeting = this.editMeetingSplitButton
        ?.toArray()
        [
          this.selectedMeetingRowIndex
        ].nativeElement?.querySelectorAll('button')[0];

      if (selectedMeeting) {
        selectedMeeting.focus();
      }
    }, 0);

    this.isDeleteAction = false;
  }

  resetToOriginal() {
    this.display = false;
    this.ngOnInit();
  }

  //isMeeting flag is used to find which meeting is selected i.e. Goverinng/Appeal
  setIsMeetingFlag(meetingType) {
    this.isMeeting = meetingType == ExclusionMeetingEnum.Meeting;
    this.isInvalidDate = false;
    this.setConditionalValidators();
  }

  //Set min appeal date (meeting date time) based on selected requested date
  setMinAppealDate(date) {
    this.minDateAppealMeeting = new Date(date);
    this.appealRequestedDateValidation();
  }

  //When user types manually in requested date input field
  onManualRequestedDateEntered(event) {
    const inputDate = event.target.value;
    // If requested meeting date is valid then set it as minimum appeal date.
    // Else if requested meeting date is empty then set exclusion start date as min date for appeal date
    if (
      this.dateService.IsValidDateFormat(inputDate, dateFormatEnum.ddmmyyyy)
    ) {
      this.setMinAppealDate(
        this.dateService.GetDateFromString(inputDate, dateFormatEnum.ddmmyyyy)
      );
    } else if (!this.dateService.checkEmptyDate(inputDate)) {
      this.setMinAppealDate(new Date(this.exclusion.startDate));
    }
    this.validateRequestedMeetingDate(inputDate);
  }

  // Check whether requested meeting date is valid
  validateRequestedMeetingDate(inputDate: string) {
    if (
      !this.dateService.checkEmptyDate(inputDate) ||
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyy,
        this.f.requestedDate
      )
    ) {
      return;
    }
    const dt = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );
    if (
      !this.dateControlValidationService.checkDateBeforeExclusionStartDate(
        dt,
        this.exclusionStartDate,
        this.f.requestedDate
      ) ||
      !this.dateControlValidationService.checkDateAfterExclusionEndDate(
        dt,
        this.exclusionEndDate,
        this.f.requestedDate
      ) ||
      !this.dateControlValidationService.checkDateAfterAcademicYearEndDate(
        dt,
        this.maxAcademicYearDate,
        this.f.requestedDate
      ) ||
      !this.dateControlValidationService.checkNonSchoolDate(
        dt,
        this.nonSchoolDates,
        this.f.requestedDate
      )
    ) {
      return;
    }
  }

  onManualReinstatementDateEntered(event) {
    const inputDate = event.target.value;
    if (
      !this.dateService.checkEmptyDate(inputDate) ||
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyy,
        this.f.reinstatementDate
      )
    ) {
      return;
    }
    const dt = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );
    if (
      !this.dateControlValidationService.checkDateBeforeExclusionStartDate(
        dt,
        this.exclusionStartDate,
        this.f.reinstatementDate
      ) ||
      !this.dateControlValidationService.checkDateAfterExclusionEndDate(
        dt,
        this.exclusionEndDate,
        this.f.reinstatementDate
      ) ||
      !this.dateControlValidationService.checkDateAfterAcademicYearEndDate(
        dt,
        this.maxAcademicYearDate,
        this.f.reinstatementDate
      ) ||
      !this.dateControlValidationService.checkNonSchoolDate(
        dt,
        this.nonSchoolDates,
        this.f.reinstatementDate
      )
    ) {
      return;
    }
  }

  //Check requested date and meeting date validation
  checkDateValidation() {
    this.appealRequestedDateValidation();
  }

  //When SEN Expert attended checkbox state change
  senExpertAttendedChange(isChecked: boolean) {
    if (this.isEdit && !this.isMeeting) {
      const senExpertAttendedDetailsControl = this.meetingFields.get(
        'senExpertAttendedDetails'
      );

      if (isChecked) {
        this.isSenExpertAttendedChecked = true;
        senExpertAttendedDetailsControl.setValidators(Validators.required);
      } else {
        this.isSenExpertAttendedChecked = false;
        this.confirmDialogAcceptButtonLabel = 'OK';
        if (senExpertAttendedDetailsControl.value) {
          this.confirmationService.confirm({
            message:
              'SEN expert name will be removed, do you wish to continue with the changes?',
            header: 'SEN Expert Name',
            accept: () => {
              this.clearValidationForSENExpertAttendedDetails();
            },
            reject: () => {
              this.isSenExpertAttendedChecked = true;
              this.meetingFields.get('senExpertAttended').setValue(true);
            }
          });
        } else {
          this.clearValidationForSENExpertAttendedDetails();
        }
      }
    }
  }

  //clear Validation For SEN Expert Attended Details input box
  clearValidationForSENExpertAttendedDetails() {
    const senExpertAttendedDetailsControl = this.meetingFields.get(
      'senExpertAttendedDetails'
    );
    this.isSenExpertAttendedChecked = false;
    senExpertAttendedDetailsControl.setValue('');
    senExpertAttendedDetailsControl.clearValidators();
    senExpertAttendedDetailsControl.reset();
    senExpertAttendedDetailsControl.updateValueAndValidity();
  }
  // Save Governing/Appeal meeting
  saveMeeting() {
    this.isSaveClicked = true;
    if (!this.meetingFields.valid) {
      this.validateFormDataService.validateAllFormFields(this.meetingFields);
      this.isSaveClicked = false;
      return;
    }
    if (this.isInvalidDate) {
      this.isSaveClicked = false;
      return;
    }
    if (this.isInputDateInValid) {
      this.isSaveClicked = false;
      return;
    }

    this.meeting = this.meetingFields.value;

    if (this.isMeeting) {
      this.meeting.meetingDateTime = this.datePipe.transform(
        this.meetingFields.get('meetingDateTime').value,
        this.datetimeFormat
      );
    } else {
      this.meeting.requestedDate = this.datePipe.transform(
        this.meetingFields.get('requestedDate').value,
        this.dateFormat
      );
      this.meeting.meetingDateTime = this.datePipe.transform(
        this.meetingFields.get('appealMeetingDateTime').value,
        this.datetimeFormat
      );
    }
    this.meeting.reinstatementDate = this.datePipe.transform(
      this.meetingFields.get('reinstatementDate').value,
      this.dateFormat
    );
    if (this.isEdit) this.updateMeeting();
    else this.createMeeting();
  }

  //Function is used to create meeting
  createMeeting() {
    let apiRoute = '';
    // Set focus on the first element when create new meeting
    this.selectedMeetingRowIndex = 0;

    if (this.isMeeting) {
      apiRoute = EXCLUSION_ENDPOINT.CreateExclusionMeeting.replace(
        '{exclusionId}',
        this.exclusionId.toString()
      );
    } else {
      apiRoute = EXCLUSION_ENDPOINT.CreateExclusionAppeal.replace(
        '{exclusionId}',
        this.exclusionId.toString()
      );
    }
    this.apiService.postWithResponseHeader(apiRoute, this.meeting).subscribe({
      next: () => {
        this.dataLossService.removeComponentFromUnsavedChanges(this);
        this.notificationService.showSuccess(
          'The meeting record has been saved successfully.'
        );
        this.resetToOriginal();
      },
      error: (x: any) => {
        this.isSaveClicked = false;
        this.notificationService.showError(
          'Something went wrong, please try again.'
        );
        this.loggingService?.logError(x);
      }
    });
  }

  //Function is used to update meeting
  updateMeeting() {
    let apiRoute = '';
    if (this.isMeeting) {
      apiRoute = EXCLUSION_ENDPOINT.UpdateExclusionMeeting.replace(
        '{exclusionId}',
        this.exclusionId?.toString()
      ).replace('{meetingId}', this.meetingAppealId?.toString());
    } else {
      apiRoute = EXCLUSION_ENDPOINT.UpdateExclusionAppeal.replace(
        '{exclusionId}',
        this.exclusionId?.toString()
      ).replace('{appealId}', this.meetingAppealId?.toString());
    }

    this.apiService.putWithResponseHeader(apiRoute, this.meeting).subscribe({
      next: () => {
        this.dataLossService.removeComponentFromUnsavedChanges(this);
        this.notificationService.showSuccess(
          'The meeting record has been updated successfully.'
        );
        this.resetToOriginal();
        //Update exclusion category and reinstate fields in exclusion details component
        if (
          this.isFixedPeriodOrPermanent() &&
          this.isOutcomeReinstate(this.meeting?.decisionResult)
        ) {
          this.messagingService.sendAlert('reinstate');
        }
        //Show Date Off Roll field in exclusion details component if Govn Body meeting outcome is upheld
        else if (this.isOutcomeUpheld(this.meeting?.decisionResult)) {
          this.messagingService.sendAlert('upheld');
        }
        //Remove Date Off Roll field in exclusion details component if Govn Body meeting outcome is  upheld and changed to deffered
        else if (this.isOutcomeDeffered(this.meeting?.decisionResult)) {
          this.messagingService.sendAlert('deferred');
        }
      },
      error: (x: any) => {
        this.isSaveClicked = false;
        if (
          x.error.statusCode === 409 &&
          x.error.code === '1.1.409.51' &&
          x.error.message === err_requested_date_after_start_date_api_msg
        ) {
          this.notificationService.showError(
            err_requested_date_after_start_date
          );
        } else {
          this.notificationService.showError(
            'Something went wrong, please try again.'
          );
        }
        this.loggingService?.logError(x);
      }
    });
  }

  resetData() {
    //Reset Data method is required in Unsaved changes template
  }
  canDeactivate() {
    return this.dataLossService.isDirty();
  }

  private setDiscernibleTextMeetingCards() {
    this.accessibilityService.splitButtonSetTitleMeetings(
      this.allMeetings,
      'Manage Meeting'
    );
  }

  private setDiscernibleTextAddEditMeetingPopUp() {
    this.accessibilityService.setDescirnibleTextPopUpAddEdit(
      this.addEditMeetingPopUp,
      this.isMeeting,
      this.isReinstateFieldsVisible
    );
  }

  private setCalendarButtonDiscernibleText() {
    if (this.elementRef) {
      this.accessibilityService.setefaultAttributesForIndependentCalendar(
        this.elementRef
      );
    }
  }

  private setDialogBoxAriaAttributes() {
    if (this.addEditMeetingPopUp) {
      const title = this.isEdit ? this.popupHeaderText : 'Add a meeting';
      this.accessibilityService.setDialogBoxAriaAttributes(
        this.addEditMeetingPopUp,
        title
      );

      // Set id to attribute ArialabelledBy of dialog box
      this.accessibilityService.setDialogAriaLabelledBy(
        this.addEditMeetingPopUp,
        'addEditMeeting'
      );
    }
  }

  private setAttributesForAlertBox() {
    if (this.elementRef) {
      this.accessibilityService.setAttributesForAlertBox(this.elementRef);
    }
  }

  // Set attributes of the dropdown
  private setDropdownAttributes() {
    // Set attributes of the meeting type dropdown
    if (this.dropdownMeetingType) {
      const props = new Map<string, string>();
      props.set('title', 'Meeting types');
      this.accessibilityService.setDropDownItemsAttributes(
        this.dropdownMeetingType,
        props
      );
      // Remove aria -expanded attribute
      this.accessibilityService.removeAriaExpandedAttribute(
        this.dropdownMeetingType
      );
    }
    // Set attributes of the meeting status dropdown
    if (this.meetingStatusDropdown) {
      const props = new Map<string, string>();
      props.set('title', 'Meeting status');
      this.accessibilityService.setDropDownItemsAttributes(
        this.meetingStatusDropdown,
        props
      );
      // Remove aria -expanded attribute
      this.accessibilityService.removeAriaExpandedAttribute(
        this.meetingStatusDropdown
      );

      // set value to aria-activedescendant attribute
      this.accessibilityService.setDropDownAriaActiveDescendant(
        this.meetingStatusDropdown,
        'meetingStatus'
      );
    }
    // Set attributes of the meeting outcome dropdown
    if (this.meetingOutcomeDropdown) {
      const props = new Map<string, string>();
      props.set('title', 'Meeting outcomes');
      this.accessibilityService.setDropDownItemsAttributes(
        this.meetingOutcomeDropdown,
        props
      );
      // Remove aria -expanded attribute
      this.accessibilityService.removeAriaExpandedAttribute(
        this.meetingOutcomeDropdown
      );

      // set value to aria-activedescendant attribute
      this.accessibilityService.setDropDownAriaActiveDescendant(
        this.meetingOutcomeDropdown,
        'meetingOutcome'
      );
    }
    // Set attributes of the reinstate reason dropdown
    if (this.reinstateReasonDropdown) {
      const props = new Map<string, string>();
      props.set('title', 'Reinstate reasons');
      this.accessibilityService.setDropDownItemsAttributes(
        this.reinstateReasonDropdown,
        props
      );
      // Remove aria -expanded attribute
      this.accessibilityService.removeAriaExpandedAttribute(
        this.reinstateReasonDropdown
      );
    }
  }

  ngAfterContentChecked(): void {
    this.setDiscernibleTextAddEditMeetingPopUp();
    this.setDiscernibleTextMeetingCards();
    this.setCalendarButtonDiscernibleText();
    this.setDialogBoxAriaAttributes();
    this.setAttributesForAlertBox();
    this.setDropdownAttributes();
    this.setAccessibleNameForDropdownButtons();
    this.validateDateInputs();
    this.setLandmarkRoleForDropdowns();
    this.removeRoleAttributeForDropDowns();
    this.removeAriaExpandedAttributeForSplitButton();
  }

  // Remove aria expanded attributes to fix axe tool issues for split button
  private removeAriaExpandedAttributeForSplitButton() {
    if (this.allMeetings) {
      this.accessibilityService.removeAriaExpandedAttributeForMeetingsSplitButtons(
        this.allMeetings
      );
    }
  }

  // Ensures every ARIA button, link and menu item has an accessible name
  private setAccessibleNameForDropdownButtons() {
    if (this.dropdownMeetingType) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.dropdownMeetingType,
        'Select meeting type'
      );
    }

    if (this.meetingStatusDropdown) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.meetingStatusDropdown,
        'Select meeting status'
      );
    }

    if (this.meetingOutcomeDropdown) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.meetingOutcomeDropdown,
        'Select meeting outcome'
      );
    }
  }

  //find and assign the rowIndex to variable
  findMeetingIndex(index) {
    this.meetingIndex = index;
  }

  //set focus on splitbutton from where delete popup is called
  setFocusOnSplitButtonMenu() {
    let isCurrentRowExists: boolean =
      this.meetingIndex + 1 <= this.meetings?.length ? true : false;
    if (!isCurrentRowExists && this.meetings?.length > 0) {
      isCurrentRowExists = true;
      this.meetingIndex = this.meetingIndex - 1;
    }

    // If current row is not available then check if there are any records available
    setTimeout(() => {
      if (isCurrentRowExists) {
        this.editMeetingSplitButton
          .find(
            (x) =>
              x.nativeElement?.attributes['ri'].nodeValue ===
              String(this.meetingIndex)
          )
          ?.nativeElement?.querySelector('.p-button-icon-only')
          ?.focus();
      }

      this.isDeleteAction = false;
    }, 0);
  }

  // Ensures all page content is contained by landmarks
  private setLandmarkRoleForDropdowns() {
    if (this.dropdownMeetingType) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.dropdownMeetingType
      );
    }
    if (this.meetingStatusDropdown) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.meetingStatusDropdown
      );
    }
    if (this.meetingOutcomeDropdown) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.meetingOutcomeDropdown
      );
    }
    if (this.reinstateReasonDropdown) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.reinstateReasonDropdown
      );
    }
  }

  // Ensures role attribute has an appropriate value for the element
  private removeRoleAttributeForDropDowns() {
    if (this.dropdownMeetingType) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.dropdownMeetingType
      );
    }
    if (this.meetingStatusDropdown) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.meetingStatusDropdown
      );
    }
    if (this.meetingOutcomeDropdown) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.meetingOutcomeDropdown
      );
    }
    if (this.reinstateReasonDropdown) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.reinstateReasonDropdown
      );
    }
  }
}
